'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'rainbow';
var width = 640;
var height = 512;
var aliases = [127752];
var unicode = 'f75b';
var svgPathData = ['M112 352l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-79.5 64.5-144 144-144s144 64.5 144 144l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-114.9-93.1-208-208-208S112 237.1 112 352z', 'M64 352C64 210.6 178.6 96 320 96S576 210.6 576 352l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64C640 175.3 496.7 32 320 32S0 175.3 0 352l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64zm224 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-53-43-96-96-96s-96 43-96 96l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;